/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */
import { ENDPOINTS } from "./Endpoints";

export let APIGateways = {};

export const initializeApiGateways = () => {
	APIGateways = {
		promptsInfoEndpoint: `${ENDPOINTS.ADMIN_API}/promptsInfo`,
		updatePromptEndpoint: `${ENDPOINTS.ADMIN_API}/updatePrompt`,
		uploadToS3Endpoint: `${ENDPOINTS.ADMIN_API}/uploadToS3`,
		checkCsvProcessingStateEndpoint: `${ENDPOINTS.ADMIN_API}/checkCsvProcessingState`,
		promptUtilEndpoint: `${ENDPOINTS.ADMIN_API}/promptUtil`,
		settingsInfoEndpoint: `${ENDPOINTS.ADMIN_API}/settingsInfo`,
		updateSettingEndpoint: `${ENDPOINTS.ADMIN_API}/updateSetting`,
		connectQueuesEndpoint: `${ENDPOINTS.ADMIN_API}/connectQueues`,
		connectLookupsEndpoint: `${ENDPOINTS.SHARED_API}/connectLookups`,
		connectReportsEndpoint: `${ENDPOINTS.SHARED_API}/connectReports`,
		webChatConfigEndpoint: `${ENDPOINTS.ADMIN_API}/webchatconfig`,
		webChatTranslationTerminologyEndpoint: `${ENDPOINTS.ADMIN_API}/translateTerminology`,
		configEndpoint: `${ENDPOINTS.SHARED_API}/config`,
		licenseCheckEndpoint: `${ENDPOINTS.SHARED_API}/licenseCheck`,
		closingHoursEndpoint: `${ENDPOINTS.ADMIN_API}/closingHours`,
		dispositionEndpoint: `${ENDPOINTS.ADMIN_API}/dispositions`,
		voicemailAudioEndpoint: `${ENDPOINTS.ACVM_API}/voicemailAudio`,
		callMeNowConfigEndpoint: `${ENDPOINTS.ADMIN_API}/callMeNowConfigs`,
		userAPIEndpoint: `${ENDPOINTS.ADMIN_API}/userManagement`,
		cannedResponsesEndpoint: `${ENDPOINTS.ADMIN_API}/cannedResponses/categories`,
		externalContactsEndpoint: `${ENDPOINTS.ADMIN_API}/externalContacts`,
		contactAttributesEndpoint: `${ENDPOINTS.ADMIN_API}/contactAttributes`,
		teamsEndpoint: `${ENDPOINTS.ADMIN_API}/teams`,
		callHistoryEndpoint: `${ENDPOINTS.ADMIN_API}/callhistory`,
		sentimentAnalysisEndpoint: `${ENDPOINTS.ADMIN_API}/sentimentAnalysis`,
		notesEndpoint: `${ENDPOINTS.ADMIN_API}/notes`,
		statusAlertsEndpoint: `${ENDPOINTS.ADMIN_API}/statusAlerts`,
		reportEndpoint: `${ENDPOINTS.ADMIN_API}/scheduledReports`,
		voicemailEndpoint: `${ENDPOINTS.ACVM_API}`,
		thirdPartyApplicationsEndpoint: `${ENDPOINTS.ADMIN_API}/thirdPartyConnectorApplications`,
		pinpointApplicationsEndpoint: `${ENDPOINTS.ADMIN_API}/pinpoint`,
		thirdPartyChatEndpoint: `${ENDPOINTS.ADMIN_API}/thirdPartyConnector`,
		lexBotsV2Endpoint: `${ENDPOINTS.ADMIN_API}/lexBotsV2`,
		videoChimeEndpoint: `${ENDPOINTS.ADMIN_API}/videoMeeting`,
		emailEndpoint: `${ENDPOINTS.ADMIN_API}/email`,
		emailDomainsEndpoint: `${ENDPOINTS.ADMIN_API}/email/domains`,
		startTeamsConversationEndpoint: `${ENDPOINTS.ADMIN_API}/teams/conversation`,
		getTeamsConversationStatusEndpoint: `${ENDPOINTS.ADMIN_API}/teams/conversation/status`,
		azureAdEndpoint: `${ENDPOINTS.ADMIN_API}/azure`,
		queueConfigEndpoint: `${ENDPOINTS.ADMIN_API}/queues`,
	};
};

initializeApiGateways();
